(function(document) {

    let selectors = {
        productCards: '.product-card',
        curCollectionSales: '.filters-box[attr-collection="sale"]',
        filterAvailability: '.filter-box input[attr-type-filter="availability"]',
        filterAvailabilityBox: '.filter-box[attr-type-filter="availability"]',
    };
  
    let productCards = document.querySelectorAll(selectors.productCards);
    let curCollectionSales = document.querySelector(selectors.curCollectionSales);
    let filterAvailability = document.querySelector(selectors.filterAvailability);
    let filterAvailabilityBox = document.querySelector(selectors.filterAvailabilityBox);
   

    addEventListener("load", (event) => {

        // filterAvailability.click()
        // filterAvailabilityBox.classList.add("opened")

        // if (curCollectionSales) {
        //     filterAvailability.click()
        //     filterAvailabilityBox.classList.add("opened")
        // }
    });

    productCards.forEach(function(productCard){

        let product_handle = productCard.getAttribute("attr-handle")
        jQuery.getJSON('/products/'+product_handle+'.js', function(productSel) {
            let variant_title = productCard.getAttribute("attr-variant-title")
            let squareSizes = productCard.querySelectorAll(".variations-sizes .square-size")

            productSel.variants.forEach(function(productSelVariants){
                if (variant_title.includes(productSelVariants.option1)) {
                    
                    // console.log(variant_title+" | "+productSelVariants.option1)

                    squareSizes.forEach(function(squareSize){
                        let squareSizeValue = squareSize.getAttribute("attr-value")
                        
                        if (productSelVariants.option2 == squareSizeValue) {

                            squareSize.classList.add("exist")
                            if (productSelVariants.available == false) {
                                squareSize.classList.add("sold-out")
                            } else {
                                squareSize.classList.remove("sold-out")
                            }
                        }
                        if (product_handle == "union-falcor-l") {
                            squareSize.classList.add("exist")
                            if (productSelVariants.available == false) {
                                squareSize.classList.add("sold-out")
                            } else {
                                squareSize.classList.remove("sold-out")
                            }
                        }
                    })
                }
            })




            // var array_size_available = []
            // var array_size_available_inventory_quantity = []

            // productSel.variants.forEach((variant) => {
                
            //     if ( variant.option1 == val_select_color ) {
            //     array_size_available.push(variant.option2)
            //     array_size_available_inventory_quantity.push(variant)
            //     } 

            // })
            // array_size_available_inventory_quantity.forEach((single_variant, index_variant) => {
                
            //     if ( single_variant.available == false ) {
            //     setTimeout(function(){ 
            //         $(".variations-sizes .square-size").not(".unavailable").eq(index_variant).addClass("soldout")
            //     }, 200);
            //     } else {
            //     $(".variations-sizes .square-size").not(".unavailable").eq(index_variant).removeClass("soldout")
            //     }

            // })

            // if ( array_size_available.indexOf("Extra Small") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='Extra Small']").addClass("unavailable")
            // }
            // if ( array_size_available.indexOf("Small") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='Small']").addClass("unavailable")
            // }
            // if ( array_size_available.indexOf("Medium") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='Medium']").addClass("unavailable")
            // }
            // if ( array_size_available.indexOf("Large") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='Large']").addClass("unavailable")
            // }
            // if ( array_size_available.indexOf("ExtraLarge") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='ExtraLarge']").addClass("unavailable")
            // }
            // if ( array_size_available.indexOf("OSFM") == -1 ) {
            //     $(".variations-sizes .square-size[attr-value='OSFM']").addClass("unavailable")
            // }



        })
    })
    

})(document);
  